import { environment } from "../../../environments/environment";
import * as CryptoJS from 'crypto-js';
import * as jose from 'jose'

export function GeraHash(): string {
  const timestamp = Math.floor(Date.now() / 1000).toString();
  const key = environment.chaveFornecedor;
  const hash = CryptoJS.SHA256(key + '.' + timestamp).toString().toUpperCase();
  return hash;
}

export async function GeraToken(payload: any, key: string) {

  const secret = new TextEncoder().encode(key);
  const alg = 'HS256'

  const jwt_token = await new jose.SignJWT(payload)
    .setProtectedHeader({ alg })
    .setIssuedAt()
    .setExpirationTime('1h')
    .sign(secret);

  return jwt_token;
}

// export async function GetDataOfToken(token: string) {

//   const key = environment.secretTokeAuthSSO;
//   try {

//     const secret = new TextEncoder().encode(key);
//     // Verifica e decodifica o token
//     const { payload } = await jose.jwtVerify(token, secret);

//     // Retorna o payload decodificado
//     return payload;

//   } catch (error) {
//     console.error("Token inválido ou expirado:", error);
//     return null;
//   }
// }

// Função para gerar um timestamp Unix de expiração
export function generateExpirationTimestamp(minutes: number): number {
  // Obter o timestamp atual em milissegundos
  const now = Date.now();

  // Converter minutos para milissegundos
  const minutesInMilliseconds = minutes * 60 * 1000;

  // Calcular o timestamp de expiração
  const expirationTimestamp = now + minutesInMilliseconds;

  // Converter para segundos (formato Unix) e retornar
  return Math.floor(expirationTimestamp / 1000);
}

// caminho para acessar o informe de contribuição
export function caminhoInformeContribuicao(cpfRaw: string, lastYear: number, currentYear: number): string {
  const cpf = String(cpfRaw).replace(/\D/g, '').padStart(11, '0');
  const pathDefault = currentYear + '/output/informes_contribuicao/infc_' + cpf + '_' + lastYear + '_' + currentYear;

  var hash = CryptoJS.SHA256(pathDefault).toString(CryptoJS.enc.Hex).toUpperCase();
  var informe = 'infc_' + cpf + '_' + lastYear + '_' + currentYear + '_' + hash.toUpperCase() + '.pdf';

  return informe;
}
